module.exports = __webpack_public_path__ + "static/media/ruhtinas-vertical-transparent-bg-gold-300x300.459c2304.png";